import { APP_URL } from '../config';
import { ChevronIcon } from '../components/Icons';

export default function Footer(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border">
      <div className="container-page py-12">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <a href="#top" className="flex items-center gap-2 font-semibold">
            <ChevronIcon className="h-7 w-7" />
            <span className="text-lg tracking-tight">Garage</span>
          </a>
          <div className="flex flex-wrap gap-x-7 gap-y-2 text-sm text-muted">
            <a href="#features" className="hover:text-text">Features</a>
            <a href="#privacy" className="hover:text-text">Privacy</a>
            <a href="#pricing" className="hover:text-text">Pricing</a>
            <a href={APP_URL} className="hover:text-text">Log in</a>
          </div>
        </div>
        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-muted">
          This is an unofficial third-party application. Tesla, Tesla Motors, and
          the Tesla logo are trademarks of Tesla, Inc. Garage is not affiliated
          with or endorsed by Tesla, Inc.
        </p>
        <p className="mt-3 text-xs text-muted">© {year} Garage. Made in the USA.</p>
      </div>
    </footer>
  );
}
